<div class="flex w-full flex-col items-center p-4">
    <mat-chip-listbox #clientRelationsChipList multiple="true">
        <div
            class="w-full overflow-hidden text-ellipsis whitespace-nowrap font-medium leading-normal p-3"
        >
            Twoja Firma
        </div>
        <mat-chip-option [value]="clientRelations.client.id"
                         [selected]="clientRelations.client.enabled"
                         (selectionChange)="updateMainClientStatus($event)"
        >
            {{clientRelations.client.name}}
        </mat-chip-option>
        <div
            class="w-full overflow-hidden text-ellipsis whitespace-nowrap font-medium leading-normal p-3"
        >
            Firmy powiązane
        </div>
        <mat-chip-option *ngFor="let relation of clientRelations.relatedClients"
                         [value]="relation.id"
                         [selected]="relation.enabled"
                         (selectionChange)="updateRelations($event)">
            {{relation.name}}
        </mat-chip-option>
    </mat-chip-listbox>
</div>
